import useLoad from '../../../../components/hooks/useLoad';

function useLoadProfSpacToProfCourse() {
  return useLoad('api/ProfSpac/GetProfNoDeletedProfiles', 'iD_ProfileSpac', {});
}

export default useLoadProfSpacToProfCourse;
